import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
  selector: 'app-chat',
  template: `<div [style.display]="showDisplay ? 'block': 'none'">
    <button class="chat-btn" type="button" (click)="close()">x</button>
    <iframe src="https://sac-clubemontreal.ascbrazil.com.br/Chat/id/Clube_Montreal"></iframe>
  </div>`,
})
export class ChatComponent {
  public innerWidth: any;
  @Output() closeChat = new EventEmitter();
  @Input() showDisplay: boolean;

  close() {
    this.closeChat.emit(true);
  }
}
